import { render, staticRenderFns } from "./BioData.vue?vue&type=template&id=a2e38628&scoped=true"
import script from "./BioData.vue?vue&type=script&lang=js"
export * from "./BioData.vue?vue&type=script&lang=js"
import style0 from "./BioData.vue?vue&type=style&index=0&id=a2e38628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e38628",
  null
  
)

export default component.exports